import React from 'react';
import {useCartState} from '../components/cart';
import useQuery from './use-query';
import {useSettingsState} from '../components/settings';

const useCartStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const state = useCartState();
    return React.useMemo(() => state.filter(e => e.serviceId === serviceId), [state, serviceId]);
};

export default useCartStateEx;
